export default "__VITE_ASSET__CoHypsbD__"